import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class CustomTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  linkModel: BaseLinkModel;
  isVisibleCallback: Function;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    linkModel: BaseLinkModel,
    isVisibleCallback: Function
  ) {
    super(index, name)

    this.entity = entity;
    this.linkModel = linkModel;
    this.isVisibleCallback = isVisibleCallback;
  }

  @override get isVisible(): Boolean {
    return this.isVisibleCallback(this.entity);
  }

  get eventName(): String {
    return null;
  }

  get eventParams(): Object {
    return null;
  }

  get analyticsEntityType(): String {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get analyticsName(): String {
    return `custom: ${this.entity?.id}`;
  }
}
